import '../src/Components/css/Project.css';
import './Projects.css';
import { useEffect } from 'react';
const Projects = ()=>{
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return(
        <>
        <section className="project_main">
            <h2 className="project_header">Projects I Built</h2>
            <div className="project_control">

                <div className="project_lists">
                    <div className="hole_circle"></div>
                    <div className="project_image">
                        <div className="prot_img">
                        <img className="protImg_lists" src="saturn_pot.png" alt="saturn mobile view"/>
                        </div>
                        <div className="lan_img">
                        <img className="lanImg_lists" src="saturn.png" alt="saturn desktop view"/>
                        </div>
                    </div>
                    <h3 className="project_name">Saturn Meme Token</h3>
                    <p className="project_desc">
                    Saturn Meme Token is a frontend web development showcase, designed purely for demonstration purposes. This mock site highlights UI/UX design and layout skills, not a real crypto platform.
                    </p>
                    <div className="project_links">
                    <a href="https://github.com/soumengope/Saturn-Meme-Token" target="_blank" rel="noopener noreferrer">
                        <img className="project_gitImg" src="github.png" alt="github logo" />
                    </a>
                    <a href="https://soumengope.github.io/Saturn-Meme-Token/" target="_blank" rel="noopener noreferrer">
                        <img className="project_liveImg" src="visit.png" alt="globe logo" />
                    </a>
                    </div>
                </div>

                <div className="project_lists">
                    <div className="hole_circle"></div>
                    <div className="project_image">
                        <div className="prot_img">
                        <img className="protImg_lists" src="epstein_mob.png" alt="epstein mobile view"/>
                        </div>
                        <div className="lan_img">
                        <img className="lanImg_lists" src="epstein_desk.png" alt="epstein desktop view"/>
                        </div>
                    </div>
                    <h3 className="project_name">Epstein Parody</h3>
                    <p className="project_desc">
                    A darkly satirical Epstein parody site showcasing advanced frontend skills through micro-interactions, animations, and responsive design.
                    </p>
                    <div className="project_links">
                    <a href="https://github.com/soumengope/Epstein-meme" target="_blank" rel="noopener noreferrer">
                        <img className="project_gitImg" src="github.png" alt="github logo" />
                    </a>
                    <a href="https://soumengope.github.io/Epstein-meme/" target="_blank" rel="noopener noreferrer">
                        <img className="project_liveImg" src="visit.png" alt="globe logo" />
                    </a>
                    </div>
                </div>

                <div className="project_lists">
                    <div className="hole_circle"></div>
                    <div className="project_image">
                        <div className="prot_img">
                        <img className="protImg_lists" src="amazon_mob.png" alt="innobytes mobile view"/>
                        </div>
                        <div className="lan_img">
                        <img className="lanImg_lists" src="amazon_desk.png" alt="innobytes desktop view"/>
                        </div>
                    </div>
                    <h3 className="project_name">Amazon Landing page</h3>
                    <p className="project_desc">
                    A responsive Amazon-inspired homepage built with HTML, CSS, and JavaScript, showcasing modern frontend design and interactivity.
                    </p>
                    <div className="project_links">
                    <a href="https://github.com/soumengope/mini-frontend-projects/tree/main/AmazonHomepage" target="_blank" rel="noopener noreferrer">
                        <img className="project_gitImg" src="github.png" alt="github logo" />
                    </a>
                    <a href="https://soumengope.github.io/mini-frontend-projects/AmazonHomepage/" target="_blank" rel="noopener noreferrer">
                        <img className="project_liveImg" src="visit.png" alt="globe logo" />
                    </a>
                    </div>
                </div>

                <div className="project_lists">
                    <div className="hole_circle"></div>
                    <div className="project_image">
                        <div className="prot_img">
                        <img className="protImg_lists" src="innobytes_mobile.png" alt="innobytes mobile view"/>
                        </div>
                        <div className="lan_img">
                        <img className="lanImg_lists" src="innobytes_desktop.png" alt="innobytes desktop view"/>
                        </div>
                    </div>
                    <h3 className="project_name">Innobytes Internship Project</h3>
                    <p className="project_desc">
                    This Next.js showcase project features a custom CSS design, a mobile-responsive user signup form, and robust validation for an enhanced user experience. 
                    It includes sections for personal, residency, and bank information inputs.
                    </p>
                    <div className="project_links">
                    <a href="https://github.com/soumengope/innobytesFrontend" target="_blank" rel="noopener noreferrer">
                        <img className="project_gitImg" src="github.png" alt="github logo" />
                    </a>
                    <a href="https://innobytes-frontend-woad.vercel.app/" target="_blank" rel="noopener noreferrer">
                        <img className="project_liveImg" src="visit.png" alt="globe logo" />
                    </a>
                    </div>
                </div>

                <div className="project_lists">
                    <div className="hole_circle"></div>
                    <div className="project_image">
                        <div className="prot_img">
                        <img className="protImg_lists" src="portfolio_phpMob.png" alt="portfolio mobile view"/>
                        </div>
                        <div className="lan_img">
                        <img className="lanImg_lists" src="portfolio_phpDesk.png" alt="portfolio desktop view"/>
                        </div>
                    </div>
                    <h3 className="project_name">My Previous Portfolio</h3>
                    <p className="project_desc">
                    This is my previous portfolio website, showcasing my skills in web development, photography, and graphic design. It highlights my projects, expertise, and personal interests.
                    </p>
                    <div className="project_links">
                    <a href="https://github.com/soumengope/myportfolio" target="_blank" rel="noopener noreferrer">
                        <img className="project_gitImg" src="github.png" alt="github logo" />
                    </a>
                    <a href="https://soumengope.free.nf/" target="_blank" rel="noopener noreferrer">
                        <img className="project_liveImg" src="visit.png" alt="globe logo" />
                    </a>
                    </div>
                </div>

                <div className="project_lists">
                    <div className="hole_circle"></div>
                    <div className="project_image">
                        <div className="prot_img">
                        <img className="protImg_lists" src="hasslebled_mob.png" alt="hasslebled mobile view"/>
                        </div>
                        <div className="lan_img">
                        <img className="lanImg_lists" src="hasslebled_desk.png" alt="hasslebled desktop view"/>
                        </div>
                    </div>
                    <h3 className="project_name">Hasslebled Landing page</h3>
                    <p className="project_desc">
                    A modern Hasselblad-inspired camera landing page built with HTML, CSS, and JavaScript, focusing on clean design and smooth user experience.
                    </p>
                    <div className="project_links">
                    <a href="https://github.com/soumengope/mini-frontend-projects/tree/main/HassleBladLandingPage" target="_blank" rel="noopener noreferrer">
                        <img className="project_gitImg" src="github.png" alt="github logo" />
                    </a>
                    <a href="https://soumengope.github.io/mini-frontend-projects/HassleBladLandingPage/" target="_blank" rel="noopener noreferrer">
                        <img className="project_liveImg" src="visit.png" alt="globe logo" />
                    </a>
                    </div>
                </div>

                <div className="project_lists">
                    <div className="hole_circle"></div>
                    <div className="project_image">
                        <div className="prot_img">
                        <img className="protImg_lists" src="uranus_mob.png" alt="epstein mobile view"/>
                        </div>
                        <div className="lan_img">
                        <img className="lanImg_lists" src="uranus_desk.png" alt="epstein desktop view"/>
                        </div>
                    </div>
                    <h3 className="project_name">Uranus front-end website</h3>
                    <p className="project_desc">
                    A parody website that mixes humor, crypto, and bold design — using fun animations and interactive elements to highlight my frontend development skills in a unique way.
                    </p>
                    <div className="project_links">
                    <a href="https://github.com/soumengope/Uranus" target="_blank" rel="noopener noreferrer">
                        <img className="project_gitImg" src="github.png" alt="github logo" />
                    </a>
                    <a href="https://soumengope.github.io/Uranus/" target="_blank" rel="noopener noreferrer">
                        <img className="project_liveImg" src="visit.png" alt="globe logo" />
                    </a>
                    </div>
                </div>

                <div className="project_lists">
                    <div className="hole_circle"></div>
                    <div className="project_image">
                        <div className="prot_img">
                        <img className="protImg_lists" src="mycomp_mob.png" alt="mycomp mobile view"/>
                        </div>
                        <div className="lan_img">
                        <img className="lanImg_lists" src="mycomp_desk.png" alt="mycomp desktop view"/>
                        </div>
                    </div>
                    <h3 className="project_name">Mycomp Landing Page</h3>
                    <p className="project_desc">
                        This Figma-designed frontend showcase website highlights a full-service app development company, featuring an engaging layout, comprehensive services, and project achievements. 
                        It's crafted purely for display and does not represent a real business.
                    </p>
                    <div className="project_links">
                    <a href="https://github.com/soumengope/mycomp_landingPage" target="_blank" rel="noopener noreferrer">
                        <img className="project_gitImg" src="github.png" alt="github logo" />
                    </a>
                    <a href="https://mycomp-landing-page.vercel.app/" target="_blank" rel="noopener noreferrer">
                        <img className="project_liveImg" src="visit.png" alt="globe logo" />
                    </a>
                    </div>
                </div>

                <div className="project_lists">
                    <div className="hole_circle"></div>
                    <div className="project_image">
                        <div className="prot_img">
                        <img className="protImg_lists" src="springdale_mob.png" alt="mycomp mobile view"/>
                        </div>
                        <div className="lan_img">
                        <img className="lanImg_lists" src="springdale_desk.png" alt="mycomp desktop view"/>
                        </div>
                    </div>
                    <h3 className="project_name">Springdale front-end project</h3>
                    <p className="project_desc">
                        A responsive school website built with Next.js, showcasing academics, events, and admissions.
                    </p>
                    <div className="project_links">
                    <a href="https://github.com/soumengope/Springdale-school" target="_blank" rel="noopener noreferrer">
                        <img className="project_gitImg" src="github.png" alt="github logo" />
                    </a>
                    <a href="https://springdale-school.vercel.app/" target="_blank" rel="noopener noreferrer">
                        <img className="project_liveImg" src="visit.png" alt="globe logo" />
                    </a>
                    </div>
                </div>

                <div className="project_lists">
                    <div className="hole_circle"></div>
                    <div className="project_image">
                        <div className="prot_img">
                        <img className="protImg_lists" src="ngo_mob.png" alt="mycomp mobile view"/>
                        </div>
                        <div className="lan_img">
                        <img className="lanImg_lists" src="ngo_desk.png" alt="mycomp desktop view"/>
                        </div>
                    </div>
                    <h3 className="project_name">Pathshala NGO simple website</h3>
                    <p className="project_desc">
                        A responsive NGO website built with HTML, CSS, and JavaScript, showcasing projects, impact, and community initiatives.
                    </p>
                    <div className="project_links">
                    <a href="https://github.com/soumengope/Pathshala_NGO" target="_blank" rel="noopener noreferrer">
                        <img className="project_gitImg" src="github.png" alt="github logo" />
                    </a>
                    <a href="https://soumengope.github.io/Pathshala_NGO/" target="_blank" rel="noopener noreferrer">
                        <img className="project_liveImg" src="visit.png" alt="globe logo" />
                    </a>
                    </div>
                </div>

            </div>
        </section>
        </>
    )
}
export default Projects;